<ph-dialog [open]="open" size="xs" heading="Don't change this — tell Gable why" (ph-close)="closed.emit(null)">
    <p class="reason-lead">
        A quick reason helps Gable make better suggestions next time.
    </p>

    <ph-action-list [items]="reasonItems" (ph-select)="onPick($event.detail)"></ph-action-list>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" (click)="onCancel()">Cancel</ph-button>
    </ph-actions>
</ph-dialog>
